"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUCCESS_MESSAGES = exports.ERROR_MESSAGES = exports.VALIDATION = exports.API = exports.BUSINESS_RULES = exports.AIRPORTS = exports.COLOMBIA_CITIES = exports.TREATMENT_CATEGORIES = exports.PAGINATION = exports.FILE_UPLOAD = exports.DATE_FORMATS = exports.SUPPORTED_CURRENCIES = exports.DEFAULT_CURRENCY = exports.APP_DESCRIPTION = exports.APP_VERSION = exports.APP_NAME = void 0;
exports.APP_NAME = 'Jema Manager';
exports.APP_VERSION = '1.0.0';
exports.APP_DESCRIPTION = 'A full-service dental medical tourism platform connecting international patients with dental providers in Colombia';
exports.DEFAULT_CURRENCY = 'USD';
exports.SUPPORTED_CURRENCIES = ['USD'];
exports.DATE_FORMATS = {
    DISPLAY: 'MMM dd, yyyy',
    INPUT: 'yyyy-MM-dd',
    DATETIME: 'MMM dd, yyyy HH:mm',
    TIME: 'HH:mm'
};
exports.FILE_UPLOAD = {
    MAX_SIZE: 50 * 1024 * 1024,
    ALLOWED_TYPES: {
        IMAGES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
        DOCUMENTS: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
    },
    MAX_FILES: 10
};
exports.PAGINATION = {
    DEFAULT_PAGE_SIZE: 20,
    MAX_PAGE_SIZE: 100,
    MIN_PAGE_SIZE: 5
};
exports.TREATMENT_CATEGORIES = {
    RESTORATIVE: 'Restorative Dentistry',
    COSMETIC: 'Cosmetic Dentistry',
    SURGICAL: 'Oral Surgery',
    ORTHODONTIC: 'Orthodontics',
    PREVENTIVE: 'Preventive Care'
};
exports.COLOMBIA_CITIES = [
    'Bogotá',
    'Medellín',
    'Cali',
    'Barranquilla',
    'Cartagena',
    'Bucaramanga'
];
exports.AIRPORTS = {
    BOG: 'El Dorado International Airport (Bogotá)',
    MDE: 'José María Córdova International Airport (Medellín)',
    CLO: 'Alfonso Bonilla Aragón International Airport (Cali)',
    BAQ: 'Ernesto Cortissoz International Airport (Barranquilla)',
    CTG: 'Rafael Núñez International Airport (Cartagena)',
    BGA: 'Palonegro International Airport (Bucaramanga)'
};
exports.BUSINESS_RULES = {
    QUOTE_VALIDITY_DAYS: 30,
    BOOKING_ADVANCE_DAYS: 14,
    CANCELLATION_POLICY_HOURS: 48,
    SESSION_DURATION_MINUTES: 60,
    MAX_SESSIONS_PER_DAY: 4
};
exports.API = {
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3,
    CACHE_TTL: 300
};
exports.VALIDATION = {
    PASSWORD_MIN_LENGTH: 8,
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
    PHONE_PATTERN: /^\+?[\d\s-()]+$/,
    EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
};
exports.ERROR_MESSAGES = {
    REQUIRED_FIELD: 'This field is required',
    INVALID_EMAIL: 'Please enter a valid email address',
    INVALID_PHONE: 'Please enter a valid phone number',
    PASSWORD_TOO_SHORT: `Password must be at least ${exports.VALIDATION.PASSWORD_MIN_LENGTH} characters`,
    FILE_TOO_LARGE: `File size must be less than ${exports.FILE_UPLOAD.MAX_SIZE / 1024 / 1024}MB`,
    INVALID_FILE_TYPE: 'Invalid file type',
    NETWORK_ERROR: 'Network error. Please check your connection',
    UNAUTHORIZED: 'You are not authorized to perform this action',
    SERVER_ERROR: 'An unexpected error occurred. Please try again'
};
exports.SUCCESS_MESSAGES = {
    REGISTRATION_SUCCESS: 'Account created successfully',
    LOGIN_SUCCESS: 'Welcome back!',
    PROFILE_UPDATED: 'Profile updated successfully',
    QUOTE_SUBMITTED: 'Quote request submitted successfully',
    BOOKING_CONFIRMED: 'Booking confirmed successfully',
    PAYMENT_SUCCESS: 'Payment processed successfully'
};
//# sourceMappingURL=index.js.map